(function() {
  if (window.youtubeModalInitialized) return;
  window.youtubeModalInitialized = true;

  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-youtube-modal-trigger]');
    if (trigger) {
      e.preventDefault();
      const modalId = trigger.getAttribute('data-youtube-modal-trigger');
      const modal = document.getElementById(modalId);

      if (modal) {
        const container = modal.querySelector('[data-youtube-container]');
        if (container && !container.querySelector('iframe')) {
          const embedUrl = container.getAttribute('data-embed-url');
          const iframe = document.createElement('iframe');
          iframe.src = embedUrl;
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
          iframe.setAttribute('allowfullscreen', 'true');
          iframe.setAttribute('aria-label', 'video');
          iframe.className = 'tw-w-full tw-h-full';
          container.appendChild(iframe);
        }

        // Position modal - full screen 
        modal.style.top = '0';

        modal.classList.remove('tw-hidden');
        modal.classList.add('tw-flex');
        document.body.style.overflow = 'hidden';
      }
    }

    const closeBtn = e.target.closest('[data-youtube-modal-close]');
    if (closeBtn) {
      const modalId = closeBtn.getAttribute('data-youtube-modal-close');
      closeYoutubeModal(modalId);
    }

    if (e.target.classList.contains('youtube-video-modal')) {
      closeYoutubeModal(e.target.id);
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const openModal = document.querySelector('.youtube-video-modal.tw-flex');
      if (openModal) {
        closeYoutubeModal(openModal.id);
      }
    }
  });

  function closeYoutubeModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      const iframe = modal.querySelector('iframe');
      if (iframe) {
        iframe.remove();
      }
      modal.classList.add('tw-hidden');
      modal.classList.remove('tw-flex');
      document.body.style.overflow = '';
    }
  }
})();